import React, { useEffect, useState } from "react";
import { CustomDialog, CustomIconButton, CustomTextField, icon } from "../../../../../../../../../common/components";
import { translate } from "../../../../../../../../../common/providers";
import styles from "./ViewCreationHeader.module.css";

export default function ViewCreationHeader({ name, onChangeName, onGoBack }) {
	const [tempName, setTempName] = useState("");
	const [openNameDialog, setOpenNameDialog] = useState(false);
	useEffect(() => {
		setTempName(name);
	}, [name]);
	const handleOpenNameDialog = () => {
		setOpenNameDialog((prev) => !prev);
	};
	const handleChangeName = (value) => {
		setTempName(value);
	};
	const handleSubmitName = () => {
		onChangeName(tempName);
		handleOpenNameDialog();
		setTempName("");
	};
	const handleCancel = () => {
		handleOpenNameDialog();
		setTempName(name);
	};
	return (
		<div className={styles.header}>
			<CustomIconButton icon={icon.faArrowLeft} iconColor="var(--grey-600)" size="md" onClick={onGoBack} />
			<span>{name}</span>
			<CustomIconButton
				icon={icon.faPenToSquare}
				iconColor="var(--grey-600)"
				size="sm"
				variant="outlined"
				onClick={handleOpenNameDialog}
			/>
			<CustomDialog
				isForm
				open={openNameDialog}
				submitDisabled={tempName === name || tempName?.length === 0}
				title={translate("dsi.form-studio.view.creation.name")}
				onClose={handleCancel}
				onSubmit={handleSubmitName}
			>
				<CustomTextField
					fullWidth
					className={styles.nameInput}
					label={translate("dsi.form-studio.view.creation.name")}
					size="small"
					value={tempName}
					variant="outlined"
					onChange={(e) => handleChangeName(e.target.value)}
				/>
			</CustomDialog>
		</div>
	);
}
